import React from "react";
import LegalLayout from "../../components/portal/LegalLayout";

export default function TermsOfUsePage() {
  return (
    <LegalLayout title="Terms of Use">
      <p>
        Welcome to Antarctic Press! By accessing or using our platform, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using Antarctic Press, you confirm that you are at least 18 years old and capable of entering into legally binding agreements.
      </p>

      <h2>2. Use of the Fund Go Platform</h2>
      <p>
        You may use Fund Go to create, back, or manage crowdfunding campaigns in accordance with all applicable laws and regulations. You may not use the platform for illegal, fraudulent, or harmful purposes.
      </p>

      <h2>3. User Accounts</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        All content and materials on Antarctic Press, including logos, branding, and designs, are owned by Antarctic Press or its licensors. You may not copy or distribute content without permission.
      </p>

      <h2>5. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access to Antarctic Press if you violate these Terms or misuse the platform.
      </p>

      <h2>6. Disclaimers</h2>
      <p>
        Antarctic Press is provided "as is" and without warranties of any kind. We do not guarantee the success of any Fund Go campaign or the performance of any user.
      </p>

      <h2>7. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of the platform after changes constitutes acceptance of the new terms.
      </p>

      <h2>8. Contact</h2>
      <p>
        If you have questions about these Terms, please contact us at <a href="mailto:support@antarcticpress.com">support@antarcticpress.com</a>.
      </p>
    </LegalLayout>
  );
}
